// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"23":"1f168d03","237":"cc8826dd","297":"a0438395","509":"7fb2820f","615":"357e484a","696":"a4ad49c8","766":"aa58a36f","925":"cc8826dd"}[chunkId] + ".css";
};